export default __webpack_public_path__ + "static/media/certificado-4.56123e30.webp";